<template>
  <div style="height: auto ;text-indent:2em;" v-loading.body="loading" v-html="html"></div>
</template>
<style>

</style>
<script>
  export default{
    // 使用时请使用 :url.sync=""传值
    props: {
      url: {
        required: true
      }
    },
    data () {
      return {
        loading: false,
        html: ''
      }
    },
    watch: {
      url (value) {
        this.load(value)
      }
    },
    mounted () {
      this.load(this.url)
    },
    methods: {
      load (url) {
        if (url && url.length > 0) {
          // 加载中
          this.loading = true
          let param = {
            accept: 'text/html, text/plain'
          }
          this.$get(url, param).then((data) => {
            this.loading = false
            // 处理HTML显示
            this.html = data
          }).catch(() => {
            this.loading = false
            this.html = '加载失败'
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HtmlPanel.vue?8ebd0e78